import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '@/views/Home.vue';
import I18n from '@/i18n/I18n';
import I18nHandler from '@/language/handlers/I18nHandler';
import LanguageCode, { languageCodes } from '@/language/LanguageCode';
import LanguageFactory from '@/language/LanguageFactory';
import Locale from '@/views/Locale.vue';
import LocalizedHTMLTagHandler from '@/language/handlers/LocalizedHTMLTagHandler';
import Location from '@/views/Location.vue';
import MarkerDetail from '@/views/MarkerDetail.vue';

Vue.use(VueRouter);

const languageFactory = new LanguageFactory();
const defaultLanguage = languageFactory.default();

const routes: Array<RouteConfig> = [
    {
        path: '/:locale',
        component: Locale,
        beforeEnter: (to, from, next) => {
            const languageCode: LanguageCode = to.params.locale as LanguageCode;

            if (!languageCodes.includes(languageCode)) {
                return next(defaultLanguage.code);
            }

            const handler = new I18nHandler(new LocalizedHTMLTagHandler());
            handler.handle(languageFactory.create(languageCode));

            return next();
        },
        children: [
            {
                path: '',
                name: 'home',
                component: Home,
            },
            {
                path: 'locations/:location',
                name: 'location',
                component: Location,
                children: [
                    {
                        path: 'markers/:marker',
                        name: 'marker',
                        component: MarkerDetail,
                    },
                ],
            },
        ],
    },
    {
        path: '*',
        redirect() {
            return `${defaultLanguage.code}/`;
        },
    },
];

const router = new VueRouter({
    routes,
});

router.afterEach(() => {
    const brand = I18n.t('main.brand').toString();
    window.document.title = I18n.t('main.title', { brand }).toString();
});

export default router;
